import { createStore } from 'polotno/model/store'
import config from '../../../config'

export const bleed = 9

export const createPolotnoStore = ({ templateJSON }: { templateJSON?: any }) => {
  const store = createStore({
    key: config.polotnoApiKey, // you can create it here: https://polotno.com/cabinet/
    showCredit: false,
  })
  store.toggleBleed(true)
  if (templateJSON) {
    store.loadJSON(templateJSON)
  } else {
    const page = store.addPage()
    page.setSize({
      width: 595,
      height: 842,
    })
    page.set({ bleed })
    page.addElement({
      type: 'svg',
      src: '/address.svg',
      x: 51,
      y: 116,
      name: 'addressBox',
      width: 281,
      height: 128,
      selectable: false,
      alwaysOnTop: true,
      showInExport: true,
      draggable: false,
      contentEditable: false,
      removable: false,
      resizable: false,
      styleEditable: false,
    })
  }
  return store
}
